import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules, validationRules } from '@/support/ValidationRules';
import { Color } from '@/models/Color';
import { SubColor } from '@/models/SubColor';
import MiButton from '@/components/mi-button/MiButton';

@Component<CreateDialog>({
  components: {
    MiButton,
  },
})
export default class CreateDialog extends Vue {
  @Prop({default: null})
  protected color!: Color;

  protected newColor: Color = new Color();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;

  mounted() {
    if(this.color) {
      this.newColor = this.color.clone();
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if(this.newColor.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if(!this.newColor) {
      return;
    }

    this.newColor
      .update()
      .then((color: Color) => {
        this.isLoading = false;
        this.$emit('colorUpdated', color);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.canSaveColor) {
      return;
    }

    this.isLoading = true;
    this.newColor
    .create()
    .then((color: Color) => {
      this.isLoading = false;
      this.$emit('colorCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveColor() {
    let canSave: boolean = true
    if(!this.newColor || !this.newColor.name || !this.newColor.name.length) {
      canSave = false;
    }

    if(this.newColor.sub_colors) {
      this.newColor.sub_colors.forEach((subColor: SubColor) => {
        if(!subColor.name || !subColor.short_name) {
          canSave = false;
        }
      });
    }

    return canSave;
  }

  protected addSubColor() {
    if(!this.newColor.sub_colors) {
      this.$set(this.newColor, 'sub_colors', [new SubColor()]);
    } else {
      this.newColor.sub_colors.push(new SubColor());
    }
  }

  protected get saveButtonText() {
    if(this.newColor && this.newColor.id) {
      return 'Edit';
    }

    return 'Add';
  }

  protected get dialogHeader() {
    if(this.newColor && this.newColor.id) {
      return `Edit ${this.newColor.name}`;
    }
    return 'Create color';
  }

  protected clear() {
    this.newColor = new Color();
  }
}
